function initCtaFixedButton() {
	let height = document.documentElement.scrollHeight - document.documentElement.clientHeight - footerHeight;
	if (window.innerWidth < 768) {
		height = document.documentElement.scrollHeight - document.documentElement.clientHeight - footerHeight - sidebarHeight;
	}

	const scrolled = (window.scrollY / height) * 100;
	let scrollTrigger = ctaFixedButton.dataset.scrollTrigger || 70;
	if (scrolled > scrollTrigger && !ctaFixedButton.appeared) {
		ctaFixedButton.appeared = true;
		ctaFixedButton.classList.add("active");
	}
}
